// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clientes {\n  padding: 60px 20px 60px 20px;\n  color: #2d853b;\n}\n\n.clientes-slide-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 250px;\n}\n\n.clientes-imgs-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.clientes-imgs img {\n  width: auto;\n  height: auto;\n  max-width: 200px;\n  max-height: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
